import * as types from '../actions/action-types';
import { createSelector } from 'reselect';

const INITIAL_STATE = {
    userInfo: {},
    trustedUser: null,
    userLoading: true,
    userError: null,
    createRanks: ['MCRC'],
    greaterThanRanks: ['RAO', 'MACO', 'ERR Marketing Specialist', 'MCRC'],
    rssOssCodeList: [],
    districtCodeList: [],
    regionCodeList: [
        {
            name: 'Western',
            code: 'west'
        },
        {
            name: 'Eastern',
            code: 'east'
        }
    ],
    recruitingStationCodeList: [],
    fundedRecruitingSubStationCodeList: [],
    fundedDistrictCodeList: [],
    fundedRegionCodeList: [
        {
            name: 'Western',
            code: 'west'
        },
        {
            name: 'Eastern',
            code: 'east'
        }
    ],
    fundedRecruitingStationCodeList: [],
    categoryList: [],
    fiscalYearList: [
        {
            code: 2016,
            name: 2016
        },
        {
            code: 2017,
            name: 2017
        },
        {
            code: 2018,
            name: 2018
        },
        {
            code: 2019,
            name: 2019
        },
        {
            code: 2020,
            name: 2020
        },
        {
            code: 2021,
            name: 2021
        }
    ]
};

//user Information
export const getUserInfo = state => state.userInfo;
export const getTrustedUser = state => state.trustedUser;
export const getUserInfoLoading = state => state.userLoading;
export const getUserPermissions = createSelector(
    [getUserInfo],
    info => info.permissions.resources
);

export const getUserDisplayPermissions = createSelector(
    [getUserInfo],
    info => info.permissions.display
);

export const getRegionCodeList = state => state.regionCodeList;
export const getDistrictCodeList = state => state.districtCodeList;
export const getRecruitingStationCodeList = state =>
    state.recruitingStationCodeList;
export const getRssOssCodeList = state => state.rssOssCodeList;

//Event
export const getFundedRegionCodeList = state => state.fundedRegionCodeList;
export const getFundedDistrictCodeList = state => state.fundedDistrictCodeList;
export const getFundedRecruitingStationCodeList = state =>
    state.fundedRecruitingStationCodeList;
export const getFundedRecruitingSubStationCodeList = state =>
    state.fundedRecruitingSubStationCodeList;

export const getCategoryList = state => state.categoryList;
export const getFiscalYearList = state => state.fiscalYearList;

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.FETCH_USER_INFO) {
        return {
            ...state,
            userLoading: true,
            userInfo: {},
            trustedUser: null
        };
    } else if (action.type === types.FETCH_USER_INFO_SUCCESS) {
        return {
            ...state,
            userInfo: action.userInfo,
            trustedUser: action.userInfo.TrustingUser || null,
            userLoading: false
        };
    } else if (action.type === types.AUTH_ERROR) {
        return {
            ...state,
            userError: action.userError
        };
    } else if (action.type === types.UPDATE_DISTRICT_SUCCESS) {
        return { ...state, districtCodeList: action.payload };
    } else if (action.type === types.UPDATE_RS_SUCCESS) {
        return { ...state, recruitingStationCodeList: action.payload };
    } else if (action.type === types.UPDATE_RSS_OSS_SUCCESS) {
        return { ...state, rssOssCodeList: action.payload };
    } else if (action.type === types.UPDATE_FUNDED_DISTRICT_SUCCESS) {
        return { ...state, fundedDistrictCodeList: action.payload };
    } else if (action.type === types.UPDATE_FUNDED_RS_SUCCESS) {
        return { ...state, fundedRecruitingStationCodeList: action.payload };
    } else if (action.type === types.UPDATE_FUNDED_RSS_SUCCESS) {
        return { ...state, fundedRecruitingSubStationCodeList: action.payload };
    } else if (action.type === types.FETCH_CATEGORY) {
        return { ...state, categoryList: action.categoryList };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/data.js